import * as React from 'react';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

import { Dropdown } from '@process-advisor/process-miner/components/shared/dropdown';

const options = [
    { value: 'Task', label: 'Task' },
    { value: 'Case', label: 'Case' },
    { value: 'Invoice', label: 'Invoice' },
    { value: 'Issue', label: 'Issue' },
];

export const Entities = () => {
    const [value, setValue] = React.useState<string>();

    const onChange = (value: string) => {
        setValue(value);
        apiProvider.setEntity({entity: value, initial: false})
        apiProvider.processEventLog_File()
    };

    React.useEffect(() => {
        setValue('Issue');
        apiProvider.setEntity({entity: 'Issue', initial: true})
    }, []);

    return (
        <Dropdown
            options={options}
            onChange={onChange}
            value={value} />
    );
};


